module.exports = __webpack_public_path__ + "img/cancel-order.2c426670.svg";